.banner {
  padding: var(--space-2) var(--space-4);
  border-bottom: 1px solid var(--border);
  font-size: 14px;
}

.info {
  composes: banner;
  background: var(--accent-soft);
}

.warning {
  composes: banner;
  background: var(--warning-soft);
}

.scroll {
  flex: 1;
  overflow-y: auto;
  padding: var(--space-4);
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 860px;
  margin: 0 auto;
}

.bubble {
  border-radius: 14px;
  padding: 14px 18px;
  min-width: 0;
}

.prompt {
  composes: bubble;
  align-self: flex-end;
  max-width: 80%;
  background: var(--chrome);
  color: var(--chrome-text);
}

.promptText {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.reply {
  composes: bubble;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  background: var(--surface);
  box-shadow: 0 3px 8px rgb(2 48 71 / 10%);
}

.who {
  color: var(--muted);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.prompt .who {
  color: var(--chrome-muted);
  margin-bottom: 6px;
}

.answer {
  overflow-wrap: anywhere;
}

.answer :global(p) {
  margin: 0 0 var(--space-2);
}

.answer :global(p:last-child) {
  margin-bottom: 0;
}

.answer :global(table) {
  border-collapse: collapse;
  margin: var(--space-2) 0;
  display: block;
  overflow-x: auto;
}

.answer :global(th),
.answer :global(td) {
  border: 1px solid var(--border);
  padding: var(--space-1) var(--space-2);
  text-align: left;
}

.answer :global(th) {
  background: var(--surface-2);
}

.answer :global(code) {
  font-family: var(--mono);
  font-size: 0.92em;
  background: var(--surface-2);
  border-radius: 4px;
  padding: 0 4px;
}

.answer :global(pre) {
  background: var(--surface-2);
  border-radius: var(--radius);
  padding: var(--space-3);
  overflow-x: auto;
}

.answer :global(pre code) {
  background: transparent;
  padding: 0;
}

.answer :global(a) {
  color: var(--link);
}

.tool {
  color: var(--muted);
  font-size: 13px;
  padding-left: var(--space-2);
}

.files {
  font-size: 14px;
}

.files a {
  color: var(--link);
  margin-right: var(--space-3);
}

.end {
  color: var(--muted);
  font-size: 14px;
  border-left: 3px solid var(--border);
  padding-left: var(--space-2);
}

.error {
  composes: end;
  border-left-color: var(--danger);
}

.working {
  color: var(--muted);
  font-size: 14px;
}

.empty {
  color: var(--muted);
  text-align: center;
  margin-top: 20vh;
}

.empty p {
  margin: 0 0 var(--space-2);
}

.empty .emptyTitle {
  color: var(--text);
  font-size: 20px;
  font-weight: 900;
}
